import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import { authCRUD } from "../../../actions/auth"

/**
 * View / Edit a role (group): rename + toggle capabilities.
 * mode === 'view'  -> read-only
 * mode === 'edit'  -> editable + save (PUT /group/<id>)
 *
 * `role` is the row object from the list (id, name, capabilities, user_count).
 */
export const EditRole = ({ role, mode, setIndex, index }) => {

  const isView = mode === 'view'
  const [loading, setLoading] = useState(false)
  const [catalogue, setCatalogue] = useState([])
  const [name, setName] = useState('')
  const [selected, setSelected] = useState([])

  useEffect(() => {
    authCRUD.loadCapabilities().then((resp) => {
      setCatalogue(resp.data)
    }).catch(() => {})
  }, [])

  // Re-seed the form whenever a different role is opened.
  useEffect(() => {
    setName(role?.name || '')
    setSelected(role?.capabilities || [])
  }, [role])

  const toggle = (codename) => {
    if (isView) return
    setSelected((prev) =>
      prev.includes(codename) ? prev.filter((c) => c !== codename) : [...prev, codename]
    )
  }

  const handleSave = () => {
    if (!role) return
    setLoading(true)
    authCRUD.updateGroup(role.id, { name, capabilities: selected })
      .then(() => {
        toast.success('Role updated.', { autoClose: 7000 })
        if (setIndex) setIndex(index + 1)
      })
      .catch((error) => {
        toast.error(error?.response?.data?.name?.[0] || error?.message || 'Update failed', { autoClose: 7000 })
      })
      .finally(() => setLoading(false))
  }

  return (
    <div className="modal fade editRoleModal" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{isView ? 'Role Details' : 'Edit Role'}{role?.name ? ` — ${role.name}` : ''}</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Role Name <span className="text-danger">*</span></label>
              <input
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                readOnly={isView}
              />
            </div>
            <label className="form-label">Permissions (capabilities)</label>
            <div className="row">
              {catalogue.map((cap) => (
                <div className="col-md-6" key={cap.codename}>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`cap-${cap.codename}`}
                      checked={selected.includes(cap.codename)}
                      onChange={() => toggle(cap.codename)}
                      disabled={isView}
                    />
                    <label className="form-check-label" htmlFor={`cap-${cap.codename}`}>
                      {cap.label}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-soft-danger" data-bs-dismiss="modal">Close</button>
            {!isView && (
              <button type="button" className="btn btn-soft-success" onClick={handleSave} disabled={loading}>
                {!loading && <span><i className="las la-save la-lg"></i> Save</span>}
                {loading && <span>Please wait... <span className='spinner-border spinner-border-sm ms-2'></span></span>}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
